import { Switch, Tooltip, withStyles } from "@material-ui/core";
import swal from "sweetalert";

const SwitchCustom = withStyles({
    switchBase: {
      color: "#4f2d7f", // customize color here
      "&$checked": {
        color: "#4f2d7f", // customize checked color here
      },
      "&$checked + $track": {
        backgroundColor: "#4f2d7f", // customize track color here
      },
    },
    checked: {},
    track: {},
  })(Switch);

  const CustomSwitch=(props)=>{
    const {isActivate,label,onChange,row}=props
    return (<Tooltip
        title={isActivate ?`Deactivate ${label}`:`Activate ${label}`} //"Delete User"
        placement="top">
        <SwitchCustom
          color="#4f2d7f"
          checked={isActivate}
          onChange={() => {
            let type = isActivate? "Deactivate" : "Activate";
            swal({
              title: "Are you sure?",
              text: `Do you want to ${type} this ${label}`,
              icon: "warning",
              buttons: true,
              dangerMode: true,
            }).then((msg) => {
              if (msg) {
                onChange(row)
              }
            });
          }}
          name="checkedA"
          inputProps={{ 'aria-label': '#4f2d7f checkbox' }}
        />
      </Tooltip>)
  }  
  export default CustomSwitch